import {
  Card,
  CardBody,
  Row,
  Col,
  NavLink,
  NavItem,
  Nav,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  TabContent,
  TabPane,
  Button,
  CardHeader,
} from "reactstrap";
import "moment-timezone";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, useState, useEffect, useContext } from "react";
import {
  NavLink as DomNavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import Moment from "moment";
import ImageGallery from "react-image-gallery";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from "react-toastify";

const DeviceDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const [horizontalTabs, setHorizontalTabs] = useState("alarms");

  const [params, setParams] = useState(location.state?.value ?? "");
  const [details, setDetails] = useState();
  const [imageSrc, setImageSrc] = useState([]);
  const privileges = useContext(MainContext);

  const [showLoading, setShowLoading] = useState(false);
  const [forceRefreshCount, setForceRefreshCount] = useState(0);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.details.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
    fetchData("manual");
  }, []);

  const openDevicePortal = () => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: params,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToEndpointList = (portKey) => {
    const location = {
      pathname: "/admin/endpoints/list",
      state: {
        value: "serialNumber||" + params + "||portKey||" + portKey,
      },
    };
    history.push(location);
  };

  const enablePort = (portId, enable) => {
    setShowLoading(true);
    fetch("/api/v1/port/edit", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        portId: portId,
        state: enable,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          const action = enable ? "disabling" : "enabling";
          toast.error(`A problem occurred while ${action} the port`, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          const action = enable ? "disabled" : "enabled";
          toast.success(`Port ${action} successfully`, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const fetchData = (mode) => {
    fetch("/api/v1/device/details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: params,
        mode: mode,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.data) {
          setDetails(actualData.data);

          const loadImage = async (pos) => {
            try {
              const imageModule = await import(
                `../../../assets/img/devices/${actualData.data.productClass}/${pos}.png`
              );
              return imageModule.default;
            } catch (Exception) {
              return null;
            }
          };

          const loadImages = async () => {
            const promises = [];
            for (var x = 1; x <= 4; x++) {
              promises.push(loadImage(x));
            }

            const images = await Promise.all(promises);
            const finalImages = [];
            images.map((image) => {
              if (image != null) {
                finalImages.push({ original: image, thumbnail: image });
              }
            });
            setImageSrc(finalImages);
          };

          loadImages();
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const deviceColumns = useMemo(
    () => [
      {
        Header: "Severity",
        accessor: "severity",
        sortBy: "severity",
        Cell: (props) => {
          let value = props.value.toUpperCase();

          // Set the right background color base on the delay
          var color = "";
          if (value == "CR") {
            color = "rgba(232, 80, 77, 1)"; // Muted Red
          } else if (value == "MJ") {
            color = "rgba(237, 145, 49, 1)"; // Soft Orange
          } else if (value == "MN") {
            color = "rgba(240, 205, 102, 1)"; // Soft Yellow
          } else if (value == "NA") {
            color = "rgba(149, 179, 215, 1)"; // Light Steel Blue
          }
          return (
            <div style={{ backgroundColor: color, width: "100%" }}>{value}</div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Condition",
        accessor: "condition",
        sortBy: "condType",
        flex: "1 1 0",
      },
      {
        Header: "Service Affecting",
        accessor: "serviceAffecting",
        sortBy: "servAff",
        Cell: (props) => {
          return <span> {props.value}</span>;
        },
        flex: "1 1 0",
      },
      {
        Header: "Description",
        accessor: "description",
        sortBy: "ifDescr",
        flex: "1 1 0",
      },
      {
        Header: "Occured",
        accessor: "occured",
        sortBy: "occurTime",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Received",
        accessor: "received",
        sortBy: "creationDate",
        Cell: (props) => {
          return (
            <div>
              {props.settings.general_convert_date_with_user_timezone === "true"
                ? Moment(props.value)
                    .tz(props.settings.user_timezone)
                    .format("yy-MM-DD hh:mm a")
                : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
            </div>
          );
        },
        flex: "1 1 0",
      },
    ],
    [],
  );

  const portsColumns = useMemo(
    () => [
      {
        Header: "Status",
        accessor: "shutdown",
        sortBy: "shutdown",
        Cell: (props) => {
          const { value, row } = props;

          const icon = value ? (
            <FaTimesCircle
              className="tableIconFontSize"
              style={{ color: "grey" }}
            />
          ) : (
            <FaCheckCircle className="text-primary tableIconFontSize" />
          );

          const tooltipId = `vmElement-${row.index}`;

          return (
            <>
              <a id={tooltipId} className="vmElement">
                {icon}
              </a>
              <ReactTooltip
                anchorSelect={`#${tooltipId}`}
                place="top"
                style={{ textAlign: "left", zIndex: "100" }}
              >
                <div>{value ? "Disabled" : "Active"}</div>
              </ReactTooltip>
            </>
          );
        },
        flex: "0 1 5%",
      },
      {
        Header: "Interface",
        accessor: "key",
        sortBy: "position",
        Cell: (props) => {
          return props.value == "Gi 1/1" ? "MGMT" : props.value;
        },
        flex: "1 1 0",
      },
      {
        Header: "Description",
        accessor: "description",
        sortBy: "description",
        flex: "1 1 0",
      },
      {
        Header: "Link Up",
        accessor: "link",
        sortBy: "link",
        Cell: (props) => {
          return props.value ? (
            <FaCheckCircle className="text-primary tableIconFontSize" />
          ) : (
            ""
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Endpoints",
        accessor: "endpointCount",
        sortBy: "endpointCount",
        flex: "1 1 0",
        Cell: (props) => {
          // Set the right background color base on the delay or the status
          var color = "";
          if (
            props.value >
            props.settings.maximum_number_coax_endpoints_tca_error_level
          ) {
            color = "rgba(232, 80, 77, 1)"; // Muted Red
          } else if (
            props.value >
            props.settings.maximum_number_coax_endpoints_tca_warning_level
          ) {
            color = "rgba(240, 205, 102, 1)"; // Soft Yellow
          }

          return (
            <div style={{ backgroundColor: color, width: "100%" }}>
              <a
                onClick={() => redirectToEndpointList(props.row.original.key)}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {props.value}
              </a>
            </div>
          );
        },
      },
      {
        Header: "",
        accessor: "actions",
        Cell: (props) => {
          return (
            <UncontrolledDropdown direction="down">
              <DropdownToggle
                caret
                color="info"
                style={{
                  padding: "6px 14px 6px 14px",
                  margin: "8px",
                }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu container={"body"}>
                {Utilities.hasAccess(privileges["devices.ports.edit"]) ? (
                  <>
                    {props.row.original.shutdown ? (
                      <DropdownItem
                        onClick={() => enablePort(props.row.original.id, false)}
                      >
                        Enable Port
                      </DropdownItem>
                    ) : (
                      <DropdownItem
                        onClick={() => enablePort(props.row.original.id, true)}
                      >
                        Disable Port
                      </DropdownItem>
                    )}
                  </>
                ) : (
                  ""
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
        flex: "1 1 0",
        padding: "0px",
        sortable: false,
        filterable: false,
      },
    ],
    [],
  );

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        {/* Breadcrumb */}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink to={{ pathname: "/admin/dashboard" }}>
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink to={{ pathname: "/admin/devices/list" }}>
                      GAM
                    </DomNavLink>
                    <i>&lt;{params}&gt;</i>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Details</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Image + infos */}
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  {imageSrc.length > 0 ? (
                    <Col md="4" className="border-end">
                      <Row className="mb-2 text-center border-bottom pb-2">
                        <Col md="6">
                          <h6>
                            {details ? details.model : ""}
                            <br />
                            <small
                              style={{ fontSize: "70%", fontWeight: "400" }}
                            >
                              Model
                            </small>
                          </h6>
                        </Col>
                        <Col md="6" className="border-start">
                          <h6>
                            {details ? details.serialNumber : ""}
                            <br />
                            <small
                              style={{ fontSize: "70%", fontWeight: "400" }}
                            >
                              Serial Number
                            </small>
                          </h6>
                        </Col>
                      </Row>
                      <ImageGallery items={imageSrc} showPlayButton={false} />
                    </Col>
                  ) : (
                    ""
                  )}

                  <Col
                    md={imageSrc.length > 0 ? 8 : 12}
                    className="d-flex flex-column"
                    style={{ minHeight: "100%" }}
                  >
                    <div className="flex-grow-1">
                      <h5>GAM Details</h5>
                      <Form>
                        <Row>
                          <Col md="4">
                            <FormGroup>
                              <label>Name</label>
                              <p>{details ? details.name : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4">
                            <FormGroup>
                              <label>MAC Address</label>
                              <p>{details ? details.macAddress : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4">
                            <FormGroup>
                              <label>Software Version</label>
                              <p>{details ? details.software : ""}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <FormGroup>
                              <label>IP Address</label>
                              <p>{details ? details.ipAddress : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4">
                            <FormGroup>
                              <label>Hardware Version</label>
                              <p>{details ? details.hardwareVersion : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4">
                            <FormGroup>
                              <label>Contact</label>
                              <p>{details ? details.contact : ""}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="4">
                            <FormGroup>
                              <label>Location</label>
                              <p>{details ? details.location : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4">
                            <FormGroup>
                              <label>Uptime</label>
                              <p>{details ? details.uptime : ""}</p>
                            </FormGroup>
                          </Col>
                          <Col md="4"></Col>
                        </Row>
                      </Form>
                    </div>

                    {sessionStorage
                      .getItem("permissions")
                      .includes("GAM_PORTAL_ACCESS") ? (
                      <div className="d-flex gap-2">
                        <Button color="info" onClick={() => openDevicePortal()}>
                          Open GAM Portal
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "alarms"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "alarms" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("alarms")}
                        >
                          Alarms
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "ports"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={horizontalTabs === "ports" ? "active" : ""}
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("ports")}
                        >
                          Ports
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>
                <TabContent
                  id="my-tab-content"
                  activeTab={horizontalTabs}
                  style={{ paddingLeft: "20px" }}
                >
                  <TabPane tabId="alarms" role="tabpanel">
                    <ReactTable
                      query="/api/v1/device/details/devices"
                      columns={deviceColumns}
                      title="Alarms"
                      param={params}
                      subtable="true"
                      className="-striped -highlight primary-pagination"
                    />
                  </TabPane>
                  <TabPane tabId="ports" role="tabpanel">
                    <ReactTable
                      query="/api/v1/device/details/ports"
                      columns={portsColumns}
                      title="Ports"
                      param={params}
                      subtable="true"
                      className="-striped -highlight primary-pagination"
                      forceRefresh={forceRefreshCount}
                    />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DeviceDetails;
